var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.982,
    height: 22.124,
    viewBox: "0 0 20.982 22.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341",
    transform: "translate(2.002 4.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M76.627,98.512,75.28,113.859H65.407L64.06,98.512l-1.706.15,1.371,15.625a1.442,1.442,0,0,0,1.423,1.285H75.539a1.445,1.445,0,0,0,1.424-1.3l1.37-15.615Z",
    transform: "translate(-62.354 -98.512)",
    fill: "#314155",
    stroke: "#314155",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5343",
    "data-name": "Group 5343",
    transform: "translate(5.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5342",
    "data-name": "Group 5342",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M153,0h-6.28A1.429,1.429,0,0,0,145.3,1.427V4.139h1.713V1.713h5.709V4.139h1.713V1.427A1.429,1.429,0,0,0,153,0Z",
    transform: "translate(-145.297)",
    fill: "#314155",
    stroke: "#314155",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345",
    transform: "translate(0 3.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5344",
    "data-name": "Group 5344",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M32.964,79.568H14.694a.856.856,0,1,0,0,1.713h18.27a.856.856,0,1,0,0-1.713Z",
    transform: "translate(-13.838 -79.568)",
    fill: "#314155",
    stroke: "#314155",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.659044f7.svg";
export { ForwardRef as ReactComponent };